import { translation } from './../lang/Translation';

// import { htmlEncode, compressImage } from '../tags/js/common';
import { BrowserHandler } from '../utils/BrowserHandler';
import { BlocklyService } from '../biz/remote/BlocklyService';
import { GlobalImport } from '../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();
import { PageContents } from '../../server/dto/PageContents';
import { UserBlockContents } from '../../server/dto/generated/UserBlockContents';
import { BackupInSession } from '../utils/BackupInSession';
import { BlocklyAframeBuilder } from './BlocklyAframeBuilder';
import { BlocklyWorkSpaceType } from '../@types/BlocklyWorkspaceType';

const t = translation;
/**
 * プロジェクトを開いてから閉じるまで有効なコンテキストオブジェクト
 * シングルトンで使い回す
 * プロジェクトが切り替わったら内容を入れ替える（インスタンスは変わらない）
 * ブロックリーワークスペースをとることができる。
 * VRHTMLを取得する際には、このオブジェクトを利用。
 * 複数のトップレベルブロックの組み合わせや、背景がない時の背景設定などを行ってからHTMLを返す。
 */
export class BlocklyStore {
  public user_id: number;
  public project_id = '';
  public title = t.to('名前のないプロジェクト', 'no_name_title');
  public js_code = '';
  public virtual_dom_js = '';

  private _workspace: BlocklyWorkSpaceType;
  get workspace(): BlocklyWorkSpaceType {
    if (!this._workspace) {
      this._workspace = null;
    }
    return this._workspace;
  }

  set workspace(value: BlocklyWorkSpaceType) {
    // console.log('workspace ', value);
    this._workspace = value;
  }

  get hasWorkSpace(): boolean {
    return this._workspace ? true : false;
  }

  get builder(): BlocklyAframeBuilder {
    return new BlocklyAframeBuilder(this.workspace, this.js_code);
  }

  dispose(): void {
    if (blocklyStore.workspace.dispose) {
      blocklyStore.workspace.dispose();
    }
  }

  get workspaceToXML(): string {
    const xml = Blockly.Xml.workspaceToDom(blocklyStore.workspace);
    return Blockly.Xml.domToText(xml);
  }

  hasBlock(xml: string): boolean {
    const _hasBlock = xml.indexOf('block') > 0;
    return _hasBlock;
  }

  /**
   * user_block_contentsに保存するメソッド
   * @param {*} is_in_server  サーバーサイド(デフォルトtrue)
   */
  async save(withCanvas = null): Promise<string> {
    try {
      const biz = new BlocklyService();
      if (withCanvas !== null) {
        // 画像付きの場合
        const comp_canvas = BrowserHandler.compressImage(withCanvas);
        await biz.saveImage(this.project_id, this.user_id, comp_canvas.toDataURL());
      }
      const xml = this.workspaceToXML;
      const code = this.builder.workspaceToCode;
      await biz.save(this.user_id, this.project_id, this.title, xml, code, this.js_code);
      new BackupInSession().appendLog(this.project_id, xml, code);
      return t.to('保存しました', 'save_success');
    } catch (error) {
      try {
        // リトライ2回目
        await this.save(withCanvas);
      } catch (error2) {
        try {
          // リトライ3回目
          await this.save(withCanvas);
        } catch (error2) {
          throw new Error(t.to('保存に失敗しました', 'save_failed'));
        }
      }
    }
  }

  /**
   * プロジェクトをサーバーから取得する
   * @param project_id
   * @param user_id
   * @returns
   */
  async getProjectFromServer(project_id: string, user_id: number): Promise<PageContents> {
    const biz = new BlocklyService();
    const result = await biz.page(project_id, user_id);
    return result.data;
  }

  isDefaultBlocklyXML(xml: string): boolean {
    const DEFAULT_XML = ` <xml xmlns="http://www.w3.org/1999/xhtml"><variables></variables></xml>`;
    const parser = new DOMParser();
    const dom = parser.parseFromString(xml, 'application/xml');
    console.log('parse', dom);
    return xml === DEFAULT_XML;
  }
  /**
   * プロジェクトを初期化する
   * @param project_id
   * @param user_id
   * @returns
   */
  async initProject(project_id: string, user_id: number): Promise<UserBlockContents> {
    const result = await this.getProjectFromServer(project_id, user_id);
    const project = result.userBlockContents;

    // 引数として受け取れるものはあらかじめセット
    this.project_id = project_id;
    this.user_id = user_id;
    this.title = project.title;

    // if (project.block_xml && !this.isDefaultBlocklyXML(project.block_xml)) {
    this.js_code = project.js_code;
    // }
    return project;
  }
}

export const blocklyStore = new BlocklyStore();
